"use client";

import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export default function EnterprisePage() {
  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-black transition-colors duration-300">
      <Header />
      <main className="flex-1 py-20 px-6">
        <div className="container mx-auto max-w-3xl text-center">
          <div className="inline-block bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 px-3 py-1 rounded-full text-xs font-semibold mb-6">
            Enterprise Solution
          </div>
          <h1 className="text-4xl font-bold mb-6 text-gray-900 dark:text-white">기업용 솔루션 도입 문의</h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-12">
            에스알컴즈의 강력한 AI 엔진을 귀사의 채용 시스템(ATS)에 직접 연동하세요.<br />
            보안과 효율성, 두 마리 토끼를 잡아드립니다.
          </p>

          <div className="bg-gray-50 dark:bg-gray-900 p-8 rounded-2xl text-left shadow-sm border border-gray-200 dark:border-gray-800">
            <form className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">회사명</label>
                  <input type="text" className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-black text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition" placeholder="(주)에스알컴즈" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">담당자 성함</label>
                  <input type="text" className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-black text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition" placeholder="홍길동" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">이메일</label>
                <input type="email" className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-black text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition" placeholder="contact@company.com" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">문의 내용</label>
                <textarea rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-black text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition" placeholder="도입 예상 규모나 궁금한 점을 적어주세요."></textarea>
              </div>
              <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-xl text-lg transition shadow-lg">
                문의하기
              </button>
            </form>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
